import { useQuery } from '@apollo/client';
import type { Policy } from '@communities/content-management/domain';
import { GET_COMMUNITY_POLICIES } from '@communities/content-management/graphql';
import { transformErrors } from '@core/adapters/errors/transformError';
import type { DomainError } from '@core/domain';
import { useMemo } from 'react';

interface CommunityPoliciesResponse {
  community: {
    id: string;
    policies: Policy[];
  } | null;
}

export function useCommunityPolicies(communityId?: string) {
  const { data, loading, error, refetch } = useQuery<CommunityPoliciesResponse>(GET_COMMUNITY_POLICIES, {
    variables: { communityId },
    fetchPolicy: 'cache-first',
    skip: !communityId,
  });

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  const policies: Policy[] = data?.community?.policies || [];

  return {
    policies,
    loading,
    errors,
    refetch,
  };
}

export default useCommunityPolicies;
